import React from 'react';
import { Button, Form, InputNumber, Checkbox } from 'antd';
import { type Ssp } from '../../hooks/useSsps';

type UpsertSspFormOverpayProps = {
  ssp?: Ssp;
  onFinish: (values: unknown) => void;
  actionButtonLabel?: string;
};

export function UpsertSspFormOverpay(props: UpsertSspFormOverpayProps) {
  const { ssp, onFinish, actionButtonLabel } = props;

  return (
    <Form layout="vertical" onFinish={onFinish}>
      <Form.Item name="overpayEnabled" valuePropName="checked" initialValue={ssp?.overpayEnabled || false}>
        <Checkbox>Overpay</Checkbox>
      </Form.Item>

      <Form.Item
        label="Overpay Budget"
        name="overpayBudget"
        initialValue={ssp?.overpayBudget}
        extra="The total budget allocated for overpaying."
      >
        <InputNumber step={0.01} min={0} style={{ width: '100%' }} placeholder="1000.00" />
      </Form.Item>

      <Form.Item
        label="Overpay Daily Budget"
        name="overpayDailyBudget"
        initialValue={ssp?.overpayDailyBudget}
        extra="The daily budget allocated for overpaying."
      >
        <InputNumber step={0.01} min={0} style={{ width: '100%' }} placeholder="100.00" />
      </Form.Item>

      <Form.Item
        label="Overpay Price %"
        name="overpayPricePercentage"
        initialValue={ssp?.overpayPricePercentage}
        extra="The percentage by which to increase the bid price."
      >
        <InputNumber step={0.1} min={0} style={{ width: '100%' }} placeholder="10.0" />
      </Form.Item>

      <Form.Item
        label="Max Overpay"
        name="maxOverpay"
        initialValue={ssp?.maxOverpay}
        extra="The maximum amount to overpay per bid."
      >
        <InputNumber step={0.01} min={0} style={{ width: '100%' }} placeholder="5.00" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          {actionButtonLabel ?? 'Save'}
        </Button>
      </Form.Item>
    </Form>
  );
}
